<template>
  <div ref="wrapper">
  </div>
</template>


<script>
export default {
  props: {
    iframeUrl: {
      type: String,
      default: null,
    },
  },
  mounted() {
    const iframe = document.createElement('iframe')
    iframe.setAttribute('src', this.iframeUrl) // 'https://widgets.prioticket.com/iYGIBbQ5')
    iframe.setAttribute('id', 'prio-widget-iframe')
    iframe.setAttribute('title', 'Product listing')
    iframe.setAttribute('scrolling', 'no')
    iframe.dataset.listing = 'true';

    iframe.style.display = 'block';
    iframe.style.width = '100%';
    iframe.style.overflow = 'visible';
    iframe.style.margin = '0px';
    iframe.style.border = '0px';

    this.$refs.wrapper.appendChild(iframe)

    const script = document.createElement('script')
    script.setAttribute('src', 'https://members-widget.fotografiska.com/js/prioApp.min.js')
    this.$refs.wrapper.appendChild(script)

  }
}
</script>